import { useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import IkigaiButton from './IkigaiButton';
import sidebarConfig from './SidebarConfig';
import {
  DrawerDesktopStyled,
  DrawerMobileStyled,
  DrawerContainerStyled,
  LogoContainerStyled,
  MainContainerSidebarStyled,
} from './styles/DashboardSidebarStyles';
import AtomFlex from '../../components/atoms/AtomFlex';
import { CustomInstanceButton } from '../../components/generics/CustomInstanceButton/CustomInstanceButton';
import { styleConfigs } from '../../components/resources/styleConfigs';
import Logo from '../../components/template-minimal/LogoComponent/Logo';
import NavSectionStudent from '../../components/template-minimal/NavSectionStudent/NavSectionStudent';
import { FeaturesEnum } from '../../constants/enums/FeaturesEnum';
import TestIdContext from '../../constants/testingAttributes/TestIdContext.enum';
import { getTestAttrs } from '../../constants/testingAttributes/testIdGenerators';
import { FeatureFlagsContext } from '../../contexts/FeatureFlagsContext';
import { isVisualFeatureEnabled } from '../../utils/featureFlags';

interface IDashboardSidebarProps {
  isOpenSidebar: boolean;
  onCloseSidebar: VoidFunction;
}

const DashboardSidebar = ({ isOpenSidebar, onCloseSidebar }: IDashboardSidebarProps): JSX.Element => {
  const { pathname } = useLocation();
  const { features } = useContext(FeatureFlagsContext);
  const visualFeatures = features.qsemVisualFeatures;
  const qsemWizardEnableCareerDiscovery = isVisualFeatureEnabled(
    visualFeatures,
    FeaturesEnum.qsemWizardEnableCareerDiscovery,
  );

  useEffect(() => {
    if (isOpenSidebar) {
      onCloseSidebar();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const renderContent = (
    <MainContainerSidebarStyled>
      <AtomFlex>
        <LogoContainerStyled tabIndex={-1}>
          <Logo isLearner testAttrs={getTestAttrs(TestIdContext.NAVIGATION, 'logo', { isLearner: String(true) })} />
        </LogoContainerStyled>
        <NavSectionStudent navConfig={sidebarConfig(features)} />
      </AtomFlex>
      {qsemWizardEnableCareerDiscovery && <IkigaiButton />}
      {features.qsemShowSidebarButton && (
        <CustomInstanceButton
          buttonText={features.qsemShowSidebarButton?.text}
          buttonLink={features.qsemShowSidebarButton?.link}
        />
      )}
    </MainContainerSidebarStyled>
  );

  return (
    <DrawerContainerStyled>
      <DrawerDesktopStyled
        open
        variant="persistent"
        PaperProps={{
          sx: {
            width: styleConfigs.dimensions.width280,
          },
        }}
      >
        {renderContent}
      </DrawerDesktopStyled>
      <DrawerMobileStyled
        open={isOpenSidebar}
        onClose={onCloseSidebar}
        PaperProps={{
          sx: { width: styleConfigs.dimensions.width280 },
        }}
      >
        {renderContent}
      </DrawerMobileStyled>
    </DrawerContainerStyled>
  );
};

export default DashboardSidebar;
